import { render } from "./PrimaryCareCommunityOrganizationScheduling.vue?vue&type=template&id=5761c4c0&scoped=true&lang=pug"
import script from "./PrimaryCareCommunityOrganizationScheduling.vue?vue&type=script&lang=js"
export * from "./PrimaryCareCommunityOrganizationScheduling.vue?vue&type=script&lang=js"

import "./PrimaryCareCommunityOrganizationScheduling.vue?vue&type=style&index=0&id=5761c4c0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5761c4c0"]])

export default __exports__